import logo from './logo.svg';
import './App.css';

import { useState, useEffect } from 'react';

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

function App() {
  const width = useWindowWidth();
  const [floater, setFloater] = useState([0, 0, false]);

  useEffect(() => {
    if(width === 0) return;

    const interval = setInterval(() => {
      setFloater(([f1, f2, dir]) => {
        let nextF1 = f1;
        let nextDir = dir;

        if (dir) {
          nextF1 += 5 + (width/100);
          if (nextF1 >= width*1.5) {
            nextF1 = width*1.5;
            nextDir = false;
          }
        } else {
          nextF1 -= 10 + (width/100);
          if (nextF1 <= (width - (width/6))) {
            nextF1 = (width - (width/6));
            nextDir = true;
          }
        }

        return [nextF1, f2, nextDir];
      });
    }, 100);

    return () => clearInterval(interval);
  }, [width]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="App-header-text">
          harrycramp.dev
        </div>
        <div className="App-header-matrix">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div className="App-header-matrix-layer">
              {Array.from({ length: Math.floor(width / 10) }).map((_, i) => {
                const rgb = 160*(((1 - Math.abs(floater[0] - i * 10) / width)) ** 2);
                return (
                  <span
                    key={i}
                    style={{
                      display: "table",
                      float: "left",
                      paddingLeft: "2px",
                      margin: "4px",
                      height: "2px",
                      transitionDuration: `${175 * idx}ms`,
                      background: `rgba(${rgb*1.2}, ${rgb}, ${rgb*1.2}, 1)`,
                    }}>
                  </span>
                );
              })}
            </div>
          ))}
        </div>
      </header>
      {// Body Content
       //
       //
       //
       //
      }
      <main className="App-body">
        <div className="App-outer-content-container">
          <div className="App-content-container">
            <div className="text-section">
              <h2>About</h2>
              <p>Harry Cramp is a Full Stack Developer based in Manchester, UK, with over five years of professional experience.</p>
              <p>Please contact here with opportunities of freelance or full-time employment, or see below for professional experience and documentation for featured projects.</p>
            </div>
            <div className="text-section">
              <h2>Experience</h2>
            </div>
            {// Experience
            //
            //
            //
            //
            }
            <div className="experience-section-container">
              <div className="experience-section-title">
                <div className="experience-section-company-name">
                  Bet365
                </div>
                <div className="experience-section-role-period">
                  3 yrs, 4 mos.
                </div>
              </div>
              <div className="experience-section-role-title">
                Full Stack Developer
              </div>
              <ul style={{ paddingLeft: width > 720 ? 40 : 20 }} className="experience-section-responsibilities-list">
                <li className="experience-desc-list-item">Designed and implemented responsive TypeScript UI and scalable
Golang-based REST API solutions to serve over 80 million customers worldwide.</li>
                <li className="experience-desc-list-item">Implemented portions of the event-driven UI using the company's in-house Gen5 framework and ported components over to React.</li>
                <li className="experience-desc-list-item">Wrote custom JavaScript and Python scripts to automate code refactoring, reducing delivery time on key projects.</li>
                <li>Orchestrated deployment pipelines on Google Cloud Platform (GCP) for reliable API deployment and
continuous integration.</li>
              </ul>
            </div>
            <div className="experience-section-container">
              <div className="experience-section-title">
                <div className="experience-section-company-name">
                  Hewlett-Packard Enterprise
                </div>
                <div className="experience-section-role-period">
                  2 yrs.
                </div>
              </div>
              <div className="experience-section-role-title">
                Software Developer
              </div>
              <ul style={{ paddingLeft: width > 720 ? 40 : 20 }} className="experience-section-responsibilities-list">
                <li className="experience-desc-list-item">Contributed to design and implementation of a business-facing cloud storage solution; ensured high code
quality through comprehensive unit and end-to-end testing.</li>
                <li className="experience-desc-list-item">Developed scalable backend solutions using Golang and Python; leveraged REST and gRPC APIs for efficient
communication.</li>
                <li className="experience-desc-list-item">Managed version control workflows and conducted code reviews via GitHub to maintain code integrity and
facilitate collaborative development.</li>
                <li className="experience-desc-list-item">Worked within containerized environments using Docker and Kubernetes, enabling seamless deployment and
scalability.</li>
                <li>Led and participated in Agile practices, serving as Scrum Master to coordinate sprints and improve team
productivity.</li>
              </ul>
            </div>
          </div>    
        </div>
      </main>
    </div>
  );
}

export default App;
